import { PlayersSearchResponseSchema, type PlayersSearchResponse } from '@/types/players';
import { apiRequest } from './client';

const BASE = '/api/v1/players';

export interface SearchPlayersParams {
  query?: string;
  position?: number; // 1..4
  team?: string; // uuid
  limit?: number; // default 40
  offset?: number; // default 0
  sort?:
  | 'selected_by_percent.desc'
  | 'selected_by_percent.asc'
  | 'total_points.desc'
  | 'total_points.asc'
  | 'now_cost.desc'
  | 'now_cost.asc';
}

export async function searchPlayers(params: SearchPlayersParams): Promise<PlayersSearchResponse> {
  const query = new URLSearchParams();
  if (params.query) query.set('query', params.query);
  if (params.position !== undefined) query.set('position', String(params.position));
  if (params.team) query.set('team', params.team);
  if (params.limit !== undefined) query.set('limit', String(params.limit));
  if (params.offset !== undefined) query.set('offset', String(params.offset));
  if (params.sort) query.set('sort', params.sort);
  const qs = query.toString();
  const url = `${BASE}/search${qs ? `?${qs}` : ''}`;
  const res = await apiRequest<unknown>({ url, method: 'GET' });
  return PlayersSearchResponseSchema.parse(res);
}

export async function getPlayersPriceRange(): Promise<{ min: number; max: number }> {
  const url = `${BASE}/price-range`;
  const res = await apiRequest<{ min: number; max: number }>({ url, method: 'GET' });
  return res;
}

